module.exports = __webpack_public_path__ + "img/3.0953eab4.png";